import { notification } from 'antd'
import { useMutation, useQueryClient } from 'react-query'
import { useTranslation } from 'react-i18next'

import { QUERY_KEYS } from '@api'
import { AxiosErrorType } from '@types'

import { TrailersApi } from './api'

const useCreateTrailer = () => {
  const { t } = useTranslation()
  const tPreffix = 'suppliers_router.suppliers_dashboard.use_create_truck.'

  const queryClient = useQueryClient()

  const onCreateSuccess = () => {
    queryClient.invalidateQueries(QUERY_KEYS.TRAILER)
  }

  const { mutate, isLoading: isLoadingTrailer } = useMutation(TrailersApi.createTrailer, {
    onSuccess: () => {
      notification.success({
        message: 'Nuevo acoplado creado correctamente',
      })
      onCreateSuccess()
    },
    onError: (err: unknown) => {
      const error = err as AxiosErrorType

      const errorResponse = error.data.error as {
        type: string
        status: number
        message: string
      }

      if (errorResponse.type === 'NO_ACTIVE_ROUTE') {
        const hint =
          errorResponse.message.length > 62
            ? `${t(`${tPreffix}no_active_route_hint`)} ${errorResponse.message.substring(
                62,
                errorResponse.message.length,
              )}`
            : `${t(`${tPreffix}no_active_route_at_all_hint`)}`

        notification.error({
          message: `${t(`${tPreffix}no_active_route`)} ${hint}`,
        })
      } else if (errorResponse.message.includes('duplicate')) {
        notification.error({
          message: 'Error, la matrícula ya existe',
        })
      } else {
        notification.error({
          message: 'Error, No se creo el vehículo',
        })
      }
    },
  })

  return {
    createTrailer: mutate,
    isLoadingTrailer,
  }
}

export { useCreateTrailer }
